const BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000/api/';
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'http://127.0.0.1:7000';
// const AGENT_SERVER = 'https://agent.loged.com.br';
const AGENT_SERVER = 'https://apichat.loged.com.br';
// const BACKEND_SERVER = 'https://api.loged.com.br/api/';

const config = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/dashboard/default',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    API_SERVER: BACKEND_SERVER
};

export default config;
